import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';

import { Routes } from '../lib/links';
import logging from '../lib/logging';
import * as SessionSelectors from '../entities/Session/selectors';
import * as styles from './styles.css';
import Button from '../components/Button/index';
import { withTranslation } from 'react-i18next';


class NotFound extends Component {
  static propTypes = {
    authenticated: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    if (this.props.authenticated) {
      logging.error('Route not found');
    }
  }

  render() {
    const { i18n } = this.props;
    return (
      <div className={styles.container}>
        <h3>{i18n.t("Den här sidan var inte bemannad.")}</h3>
        <div>{i18n.t("Tyvärr kunde vi inte hitta det du letade efter.")}</div>
        <div>{i18n.t("Är du säker på på att adressen är rätt?")}</div>
        <div className={styles.back}>
          <Button link={Routes.home()}>
            {i18n.t("Tillbaka till startsidan")}
          </Button>
        </div>
      </div>
    );
  }
}

const withAuthenticated = connect(
  state => ({ authenticated: SessionSelectors.authenticated(state) }),
);

export default compose(
  withAuthenticated,
)(withTranslation()(NotFound));
